<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData = $event"
        v-on:save="saveHandler"
        v-on:new="createHandler"
        v-on:delete="isConfirm = !isConfirm"
      />
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import AffectTypeForm from "../../../components/payroll/affectType/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": AffectTypeForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('setupaffecttype.editaffecttype'),
      pageTitleValue: " " +"",
      formData: {
        affecttypeid: null,
        affecttypecode: null,
        affecttypedesc: null,
        startdate: null,
        enddate: null,
        remark: null,
        affectitems: [],
        stamp: 0,
        userid: this.$store.getters.userId,
      },
      loading: true,
      deletedItems: [],
      insertedItems: [],
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    loadAffectType() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/affecttypedt/" + this.id})
        .then((res) => {
          if (res.data.rec[0].startdate) {
            vm.formData.startdate = moment(res.data.rec[0].startdate).format(
              "YYYY-MM-DD"
            );
          }

          if (res.data.rec[0].enddate) {
            vm.formData.enddate = moment(res.data.rec[0].enddate).format(
              "YYYY-MM-DD"
            );
          }

         // vm.formData.lockstaff = res.data.rec[0].lockstaff;
          vm.formData.affecttypeid = res.data.rec[0].affecttypeid;
          vm.formData.affecttypecode = res.data.rec[0].affecttypecode;
          vm.formData.affecttypedesc = res.data.rec[0].affecttypedesc;
         
          vm.formData.remark = res.data.rec[0].remark;
          vm.formData.stamp = res.data.rec[0].stamp;

          /*
                let items = JSON.parse(res.data.rec[0].affectitems)

                
                for (let i = 0; i < items.length; i++) {
                    vm.formData.affectitems.push(items[i]);
                }
                */

          vm.pageTitleValue = res.data.rec[0].affecttypedesc;

          // vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    loadAffectTypeDetail() {
      const vm = this;

      console.log("id", this.id);
      return this.$store.dispatch('get', {url: "/affecttyped/" + this.id})
        .then((res) => {
          console.log("res", res.data.rec);
          for (let i = 0; i < res.data.rec.length; i++) {
            this.formData.affectitems.push({
              id: res.data.rec[i].id,
              code: res.data.rec[i].affectitemcode,
              desc: res.data.rec[i].affectitemdesc,
              action: 0,
            });
          }

          // vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      this.$store.dispatch('put', {url: "/affecttypedt/" + this.id,
          payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "affecttypelist" , params: { search: this.search}  });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    deleteHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.$store.dispatch('delete', {url:
            "/affecttypedt/" +
            this.id +
            "/" +
            this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "affecttypelist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    createHandler() {
      this.$router.push({ name: "affecttypenew" });
    },

    cancelHandler() {
      this.$router.push({ name: "affecttypelist" });
    },
  },

  async mounted() {
    try {
      await this.loadAffectType();
      await this.loadAffectTypeDetail();
    } finally {
      this.loading = false;
    }
  },
};
</script>